import { render } from "./LegacyGroupThresholdAchievementReport.vue?vue&type=template&id=ab4a9f18"
import script from "./LegacyGroupThresholdAchievementReport.vue?vue&type=script&lang=js"
export * from "./LegacyGroupThresholdAchievementReport.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__